module.exports = __webpack_public_path__ + "static/media/info.157ac1b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/info.svg
// module id = 542
// module chunks = 0